var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-subheader',{staticClass:"text-caption font-italic font-weight-light pa-0",staticStyle:{"height":"auto","line-height":"1rem !important","color":"inherit","white-space":"pre-wrap"}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.computedText)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }